export const getAddressName = entry => {
  let addressName = ''

  if (
    entry.type === 'shipping' &&
    entry.pickupStation &&
    entry.pickupStation.name
  ) {
    addressName = entry.pickupStation.name
  } else {
    addressName = `${entry.firstName} ${entry.lastName}`
  }

  return addressName
}
